import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: 'button[appNoDblClick], app-action-button[appNoDblClick]',
})
export class NoDblClickDirective {
  @Input() clickTimeout = 500;

  @HostListener('click', ['$event'])
  clickEvent(event: Event) {
    event.preventDefault();
    // find first parent of button type
    // (for cases that user clicked on child elements of button - svg etc)
    if (!(event.target instanceof Element)) return;
    let element: Element = event.target as Element;
    while (element && element.tagName !== 'BUTTON' && element.parentElement) {
      element = element.parentElement;
    }
    if (element) {
      element.setAttribute('disabled', '');
      setTimeout(() => element.removeAttribute('disabled'), this.clickTimeout);
    }
  }
}
